(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-purchase-tools"] && !Shopify.designMode) return;
  try {
    function connectAmadeusPurchase() {
  document.querySelectorAll('[data-aa-purchase-tools]').forEach(bar => {
    if (bar.dataset.connected) return;
    const primary = document.getElementById(bar.dataset.primaryId);
    const trigger = bar.querySelector('[data-aa-purchase-trigger]');
    if (!primary || !trigger) return;
    bar.dataset.connected = 'true';
    const sync = () => {
      trigger.disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
      trigger.setAttribute('aria-busy', primary.classList.contains('loading') ? 'true' : 'false');
      const label = primary.querySelector('span');
      if (label) bar.querySelector('[data-aa-purchase-label]').textContent = label.textContent.trim();
    };
    sync();
    trigger.addEventListener('click', () => { if (!trigger.disabled) primary.click(); });
    new MutationObserver(sync).observe(primary, {attributes:true, childList:true, subtree:true, characterData:true});
    bar.hidden = false;
  });
}
connectAmadeusPurchase();
document.addEventListener('DOMContentLoaded', connectAmadeusPurchase, {once:true});
document.addEventListener('shopify:section:load', connectAmadeusPurchase);
  } catch(e) { console.error(e); }
})();

})();
